var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgShowLessBlue = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "18px",
    viewBox: "0 0 10 18",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "show_less-blue")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.41,16.59 L1.83,18 L5,14.83 L8.17,18 L9.58,16.59 L5,12 L0.41,16.59 Z M9.59,1.41 L8.17,0 L5,3.17 L1.83,0 L0.41,1.41 L5,6 L9.59,1.41 Z",
    id: "show_less",
    fill: "#2962FF"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShowLessBlue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/show_less-blue.cf506678.svg";
export { ForwardRef as ReactComponent };